import { Card, Col, Modal, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { createUseStyles } from 'react-jss';
import { errorCatch, Field, GET, JSXMap, Model, POST, updateInArray, useAuth } from 'fennec-ui';
import { CollectionServer } from 'fennec-ui';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import User from '../../../components/User';
import AdminUserUpdate from '../../forms/AdminUserUpdate';

var _ = require('lodash');

const useStyles = createUseStyles({
	item: {
		padding: "5px 10px",
		display: "flex",
		cursor: "pointer",
		'&:hover': {
			backgroundColor: "#f9f9f9"
		}
	},
})

export default function ConfigPage(props) {
	const classes = useStyles();
	const auth = useAuth();

	const [noCaptcha, setNoCaptcha] = useState();

	useEffect(() => {
		GET(auth, '/api/config/bykey?key=noCaptcha', res => {
			if (res && res.data) {
				setNoCaptcha(res.data);
			}
		}, errorCatch);
	}, [])
	// 
	// /api/config/setconfig
	// /api/query-delete/config/{id}


	return (
		<div>
			<Field
				key={"noCaptcha"}
				auth={auth}
				item={{
					label: "Не использовать капчу",
					name: "noCaptcha",
					type: "bool",
				}}
				value={noCaptcha?.value==="true"}
				onChange={v => {
					POST(auth, '/api/config/setconfig', {...noCaptcha, key: "noCaptcha", value: ""+v}, res => {
						if (res && res.data) {
							setNoCaptcha(res.data);
						}
					}, errorCatch);
				}}
			/>
		</div>
	);
}
